import { fetchListVerificacion } from "../http-common";

const ListarCombomGrupoVerificacion = (filter: any) => {
  return fetchListVerificacion.post(
    "GrupoVerficacion/ListarComboGrupoVerificacion",
    filter
  );
};

const GrupoVerificacionService = {
  ListarCombomGrupoVerificacion,
};

export default GrupoVerificacionService;
